import React from 'react';
import styled from 'styled-components';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import TotalModalWrapper from './TotalModalWrapper';
import LogoPath from '../../../image/CompleteSignUpLogo.png';

export default function SubscribePushModal(props) {
  const { yesFn } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  return (
    <TotalModalWrapper>
      <TopLevelWrapper backgroundColor={theme.subBackground}>
        <LogoWrapper>
          <Logo src={LogoPath} />
        </LogoWrapper>
        <ExplanationWrapper>
          <KorExplanation color={theme.text}>Link Zone을 이용하시려면</KorExplanation>
          <KorExplanation color={theme.text}>정기 구독을 진행해주세요</KorExplanation>
        </ExplanationWrapper>
        <ButtonWrapper>
          <YesButton backgroundColor={theme.primary} hoverColor={theme.primaryHover} onClick={yesFn}>
            <ButtonText color={theme.white}>진행하기</ButtonText>
          </YesButton>
        </ButtonWrapper>
      </TopLevelWrapper>
    </TotalModalWrapper>
  );
}

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: column;

  justify-content: flex-start;
  align-items: center;

	width: 476px;
	height: 298px;

	border-radius: 50px;
  background-color: ${props => props.backgroundColor};

  transition: all 0.5s ease-in-out;
`;

const LogoWrapper = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;

  // margin-top: -300px;
  margin-top: -100px;
`;

const Logo = styled.img`
  width: 200px;
  height: 200px;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  justify-content: center;
  align-items: flex-start;

  margin-top: 109px;

  width: 90%;
  // height: 100px;
`;

const KorExplanation = styled.pre`
  font-family: NotoSansKR-Bold;
  font-size: 25px;

  margin: 0 0 0 0;

  color: ${props => props.color};
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 14px;

  margin-top: 50px;
`;

const YesButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  // width: 155px;
  width: 324px;
  height: 45px;

  border-radius: 23px;
  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background: ${props => props.hoverColor};
  }
`;

const ButtonText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 18px;

  color: ${props => props.color};

  margin: 0 0 0 0;
`;
